module.exports = __webpack_public_path__ + "img/venta.1445b044.png";